import { Box, Dialog, InputLabel, Stack, TextField } from "@mui/material";
import { EditCompanyDetailsModalTypes, factoryBasicDetailColumns } from "data/supplierPageData";
import moment from "moment";
import { useState } from "react";
import {
	SupplierModalActions,
	SupplierModalHeader,
	modalContentSx,
	modalFormStack,
	supplierModalPaperProps,
} from "../../../shared/supplierUi";

const EditFactoryDetails = ({ type, basicDetails, setBasicDetails, modalOpen, setModalOpen, submitFunction }) => {
	const [updatedDetails, setUpdatedDetails] = useState(basicDetails);
	const handleCloseModal = () => {
		setUpdatedDetails(basicDetails);
		setModalOpen(false);
	};
	const handleFormSubmit = (e) => {
		e.preventDefault();
		let obj = {};
		Object.keys(factoryBasicDetailColumns).forEach((col) => {
			if (col === "factory_code") return;
			obj[col] = updatedDetails[col];
		});
		if (typeof submitFunction === "function") submitFunction(obj, setModalOpen);
	};
	const isEdit = type === EditCompanyDetailsModalTypes.edit;

	return (
		<Dialog
			fullWidth
			maxWidth="md"
			open={modalOpen}
			onClose={handleCloseModal}
			component="form"
			onSubmit={handleFormSubmit}
			PaperProps={supplierModalPaperProps}>
			<SupplierModalHeader
				title={isEdit ? "Edit factory details" : "Add factory"}
				subtitle={isEdit ? "Update licence and location information" : "Enter basic factory information"}
			/>
			<Box sx={{ ...modalContentSx, pt: 2.5 }}>
				<Stack direction="row" width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={2} columnGap={1}>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Factory Name</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.name}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, name: e.target.value })}
							placeholder="Enter Name"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Factory Licence Number</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.factory_liscence_no}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, factory_liscence_no: e.target.value })}
							placeholder="Enter Licence No"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Licence Issue Date</InputLabel>
						<TextField
							size="small"
							type="date"
							value={moment(updatedDetails?.factory_liscence_issue_date).format("YYYY-MM-DD")}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, factory_liscence_issue_date: e.target.value })}
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Licence Expiry Date</InputLabel>
						<TextField
							size="small"
							type="date"
							value={moment(updatedDetails?.factory_liscence_expiry_date).format("YYYY-MM-DD")}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, factory_liscence_expiry_date: e.target.value })}
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Factory GST No</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.factory_gst_no}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, factory_gst_no: e.target.value })}
							placeholder="Enter GST No"
							required
						/>
					</Stack>
					<Stack sx={modalFormStack} spacing={0}>
						<InputLabel>Location Link (Google Maps)</InputLabel>
						<TextField
							size="small"
							type="text"
							value={updatedDetails?.gmap_location_link}
							onChange={(e) => setUpdatedDetails({ ...updatedDetails, gmap_location_link: e.target.value })}
							placeholder="Enter Location Link"
							required
						/>
					</Stack>
				</Stack>
			</Box>
			<SupplierModalActions
				onCancel={handleCloseModal}
				submitLabel={isEdit ? "Save" : "Create"}
			/>
		</Dialog>
	);
};

export default EditFactoryDetails;
